import { behaviour, direction, pin_attribs_enum, pin_row } from "@microchip/pin-standard";
import { RowData } from "@microchip/melody-automodule-interface/lib/src/ModuleConfig";
import { AppModel } from "../generated_module/src/types/AutoModuleTypes";

// provide complete dynamic data for all pin rows. It overrides static pindata.json
export const getCompletePinData = (appModel: AppModel): any => {
    // create a RowData variable
    const rows: RowData = [];
    // Evaluate the user input
    if (appModel.getComponentValue("ioPinIndicator")) {
        // append the needed pin_row to the RowData
        rows.push({
            name: "BL_Indicator",
            module: "BOOT",
            function: "INDICATE",
            direction: direction.output,
            filter: {
                module: "GPIO",
                aliasReEx: ".*",
            },
            behaviour: behaviour.OPTIONAL_PIN_MUX,
            attribs: [
                {
                    cname: "BL_INDICATOR",
                    analog: false,
                    high: true,
                    aliasReEx: ".*",
                },
            ],
        });
    }
    if (appModel.getComponentValue("ioPinEntry")) {
        rows.push({
            name: "BL_Entry",
            module: "BOOT",
            function: "ENTRY",
            direction: direction.input,
            filter: {
                module: "GPIO",
                aliasReEx: ".*",
            },
            behaviour: behaviour.OPTIONAL_PIN_MUX,
            attribs: [
                {
                    cname: "BL_ENTRY",
                    analog: false,
                    wpu: true,
                    high: false,
                    aliasReEx: ".*",
                },
            ],
        });
    }

    // way to programatically override the json data
    return { rows: rows };
};

// overrides pin data for a particular row based on model.
export function getRowData(appModel: AppModel, rowData: pin_row): pin_row {
    const returnRowData: pin_row = rowData;

    const indicatorPinComponent: any = appModel.getComponent("ioOutPin")?.component;
    const entryPinComponent: any = appModel.getComponent("ioInPin")?.component;

    let returnRowActions = []; // attach actions if pin to register update is required
    let shouldInclude = false;
    let currentComponenet: any = undefined;

    const neededAttribs: pin_attribs_enum[] = [pin_attribs_enum.cname];

    switch (rowData.name) {
        case "BL_Indicator":
            shouldInclude = indicatorPinComponent !== undefined;
            currentComponenet = indicatorPinComponent;
            neededAttribs.push(pin_attribs_enum.high);
            break;
        case "BL_Entry":
            shouldInclude = entryPinComponent !== undefined;
            currentComponenet = entryPinComponent;
            break;
        default:
            shouldInclude = false;
            currentComponenet = undefined;
            break;
    }

    if (shouldInclude && currentComponenet) {
        returnRowActions = returnRowActions.concat(
            appModel
                .getPCPHelper?.()
                .stateActionBuilder(rowData)
                .rowWithName(rowData.name)
                .forComponent(currentComponenet)
                .addIfLockedProvideAttribs(".*", neededAttribs)
                .addIfUnlockedProvideAttribs(".*", neededAttribs)
                .build(),
        );
    }

    return { ...returnRowData, actions: returnRowActions };
}
